document.addEventListener('DOMContentLoaded', function () {

    const bandSelect = document.getElementById('band-select');
    const cupSelect = document.getElementById('cup-select');
    const resultDisplay = document.querySelector('.show-result');
    const fitResultContainer = document.querySelector('.fit-size-result');
    const allFitTexts = document.querySelectorAll('.text-result');

    const track = document.getElementById('slider-track');
    const prevBtn = document.querySelector('.prev-btn');
    const nextBtn = document.querySelector('.next-btn');
    const allSlides = document.querySelectorAll('.list-slide');
    const noImgMsg = document.querySelector('.no-img');

    let currentIndex = 0;
    let visibleSlides = [];
    let autoSlideInterval;

    track.style.cursor = 'grab';
    track.style.touchAction = 'pan-y';
    track.style.userSelect = 'none';

    const sizeMapping = {
        '60A': 'AA','65A': 'AA','70A': 'AA','75A': 'A','80A': 'B','85A': 'C','90A': 'D','95A': 'E','100A': 'F',
        '60B': 'AA','65B': 'AA','70B': 'A','75B': 'B','80B': 'C','85B': 'D','90B': 'E','95B': 'F','100B': 'G',
        '60C': 'AA','65C': 'A','70C': 'B','75C': 'C','80C': 'D','85C': 'E','90C': 'F','95C': 'G','100C': 'H',
        '60D': 'A','65D': 'B','70D': 'C','75D': 'D','80D': 'E','85D': 'F','90D': 'G','95D': 'H','100D': 'I',
        '60E': 'B','65E': 'C','70E': 'D','75E': 'E','80E': 'F','85E': 'G','90E': 'H','95E': 'I','100E': 'J',
        '60F': 'C','65F': 'D','70F': 'E','75F': 'F','80F': 'G','85F': 'H','90F': 'I','95F': 'J','100F': 'K',
        '60G': 'D','65G': 'E','70G': 'F','75G': 'G','80G': 'H','85G': 'I','90G': 'J','95G': 'K','100G': 'L',
        '60H': 'E','65H': 'F','70H': 'G','75H': 'H','80H': 'I','85H': 'J','90H': 'K','95H': 'L','100H': 'M',
        '60J': 'F','65J': 'G','70J': 'H','75J': 'I','80J': 'J','85J': 'K','90J': 'L','95J': 'M','100J': 'N',
        '60K': 'G','65K': 'H','70K': 'I','75K': 'J','80K': 'K','85K': 'L','90K': 'M','95K': 'N','100K': 'O',
        '60L': 'H','65L': 'I','70L': 'J','75L': 'K','80L': 'L','85L': 'M','90L': 'N','95L': 'O','100L': 'P',
        '60M': 'I','65M': 'J','70M': 'K','75M': 'L','80M': 'M','85M': 'N','90M': 'O','95M': 'P','100M': 'Q',
        '60N': 'J','65N': 'K','70N': 'L','75N': 'M','80N': 'N','85N': 'O','90N': 'P','95N': 'Q','100N': 'R',
        '60O': 'K','65O': 'L','70O': 'M','75O': 'N','80O': 'O','85O': 'P','90O': 'Q','95O': 'R',
        '60P': 'L','65P': 'M','70P': 'N','75P': 'O','80P': 'P','85P': 'Q','90P': 'R',
        '60R': 'M','65R': 'N','70R': 'O','75R': 'P','80R': 'Q','85R': 'R',
        '60S': 'N','65S': 'O','70S': 'P','75S': 'Q','80S': 'R',
        '60T': 'O','65T': 'P','70T': 'Q','75T': 'R',
        '60U': 'P','65U': 'Q','70U': 'R',
        '60V': 'Q','65V': 'R',
        '60W': 'R'
    };

    function checkAvailability() {
        const selectedBand = bandSelect.value;
        const selectedCup = cupSelect.value;

        Array.from(cupSelect.options).forEach(option => {
            if (option.value === "") return;
            if (selectedBand) {
                option.disabled = !sizeMapping[selectedBand + option.value];
            } else {
                option.disabled = false;
            }
        });

        Array.from(bandSelect.options).forEach(option => {
            if (option.value === "") return;
            if (selectedCup) {
                option.disabled = !sizeMapping[option.value + selectedCup];
            } else {
                option.disabled = false;
            }
        });
    }

    function updateCalculator() {
        checkAvailability();
        const band = bandSelect.value;
        const cup = cupSelect.value;

        if (band && cup) {
            const combination = band + cup;
            const resultSize = sizeMapping[combination];

            if (resultSize) {
                resultDisplay.textContent = ((window.Shopify && Shopify.locale && Shopify.locale.toLowerCase().indexOf('en') === 0) ? "BOOMBA Size " : "BOOMBA 尺寸 ") + resultSize;
                fitResultContainer.style.display = 'block';
                allFitTexts.forEach(el => el.style.display = 'none');

                const activeText = document.querySelector(`.fit-result-${resultSize.toLowerCase()}`);
                if(activeText) activeText.style.display = 'block';

                filterSlides(resultSize);
            } else {
                resultDisplay.textContent = "Size not available";
                fitResultContainer.style.display = 'none';
                filterSlides('NONE');
            }
        }
    }

    function filterSlides(targetSize) {
        currentIndex = 0;
        track.style.transform = `translateX(0)`;
        visibleSlides = [];

        allSlides.forEach(slide => {
            const slideSize = slide.getAttribute('data-size');
            if (targetSize !== 'NONE' && (targetSize === 'ALL' || slideSize === targetSize)) {
                slide.classList.remove('hide-slide');
                visibleSlides.push(slide);
            } else {
                slide.classList.add('hide-slide');
            }
        });

        if (visibleSlides.length === 0) {
            noImgMsg.style.display = 'block';
        } else {
            noImgMsg.style.display = 'none';
        }

        updateArrows();
        startAutoSlide();
    }

    function getSliderConfig() {
        const width = window.innerWidth;
        if (width <= 600) {
            return { itemsPerView: 1, slideWidth: 70, centerMode: true };
        } else if (width <= 900) {
            return { itemsPerView: 2, slideWidth: 50, centerMode: false };
        } else {
            return { itemsPerView: 3, slideWidth: 33.333, centerMode: false };
        }
    }

    function updateSliderPosition() {
        if (visibleSlides.length === 0) return;

        const config = getSliderConfig();
        let offset = 0;

        if (config.centerMode) {
            offset = (100 - config.slideWidth) / 2;
        }

        const moveAmount = -(currentIndex * config.slideWidth) + offset;
        track.style.transform = `translateX(${moveAmount}%)`;
        updateArrows();
    }

    function updateArrows() {
        const config = getSliderConfig();

        if (visibleSlides.length === 0 || visibleSlides.length <= config.itemsPerView) {
            if(!config.centerMode || visibleSlides.length === 1) {
                prevBtn.style.display = 'none';
                nextBtn.style.display = 'none';
                return;
            }
        }

        prevBtn.style.display = 'block';
        nextBtn.style.display = 'block';

        let maxIndex;
        if (config.centerMode) {
            maxIndex = visibleSlides.length - 1;
        } else {
            maxIndex = visibleSlides.length - config.itemsPerView;
        }

        prevBtn.disabled = currentIndex === 0;
        prevBtn.style.opacity = currentIndex === 0 ? '0.3' : '1';

        nextBtn.disabled = currentIndex >= maxIndex;
        nextBtn.style.opacity = currentIndex >= maxIndex ? '0.3' : '1';
    }

    function goNext() {
        const config = getSliderConfig();
        let maxIndex;

        if (config.centerMode) {
            maxIndex = visibleSlides.length - 1;
        } else {
            maxIndex = visibleSlides.length - config.itemsPerView;
        }

        if (currentIndex < maxIndex) {
            currentIndex++;
        } else {
            currentIndex = 0;
        }

        updateSliderPosition();
    }

    function goPrev() {
        if (currentIndex > 0) {
            currentIndex--;
        } else {
            currentIndex = visibleSlides.length - 1;
        }

        updateSliderPosition();
    }

    function startAutoSlide() {
        clearInterval(autoSlideInterval);
        autoSlideInterval = setInterval(() => {
            goNext();
        }, 3000);
    }

    bandSelect.addEventListener('change', updateCalculator);
    cupSelect.addEventListener('change', updateCalculator);

    nextBtn.addEventListener('click', () => {
        goNext();
        startAutoSlide();
    });

    prevBtn.addEventListener('click', () => {
        goPrev();
        startAutoSlide();
    });

    window.addEventListener('resize', function() {
        updateSliderPosition();
        updateArrows();
    });

    track.addEventListener('mouseenter', () => clearInterval(autoSlideInterval));
    track.addEventListener('mouseleave', startAutoSlide);

    let startX = 0;
    let endX = 0;
    let isDragging = false;

    track.addEventListener('touchstart', (e) => {
        startX = e.changedTouches[0].screenX;
        clearInterval(autoSlideInterval);
    }, { passive: true });

    track.addEventListener('touchend', (e) => {
        endX = e.changedTouches[0].screenX;
        handleSwipe();
        startAutoSlide();
    }, { passive: true });

    track.addEventListener('mousedown', (e) => {
        isDragging = true;
        startX = e.screenX;
        track.style.cursor = 'grabbing';
        clearInterval(autoSlideInterval);
        e.preventDefault();
    });

    track.addEventListener('mouseup', (e) => {
        if (!isDragging) return;
        isDragging = false;
        endX = e.screenX;
        track.style.cursor = 'grab';
        handleSwipe();
        startAutoSlide();
    });

    track.addEventListener('mouseleave', () => {
        if (isDragging) {
            isDragging = false;
            track.style.cursor = 'grab';
        }
    });

    function handleSwipe() {
        const threshold = 50;

        if (endX < startX - threshold) {
            goNext();
        }

        if (endX > startX + threshold) {
            goPrev();
        }
    }

    filterSlides('ALL');
    checkAvailability();
    startAutoSlide();
});